import { Extension } from "@tiptap/core"
import { Plugin, PluginKey } from "prosemirror-state"

/**
 * ProtectHeadings — TipTap Extension
 *
 * Blocks all ProseMirror transactions that modify `heading` nodes.
 *
 * OIO section headings (## N. TITLE) are legally mandated structural markers.
 * Protecting them ensures:
 *   1. GcsSectionParser can reliably locate sections by ## anchor.
 *   2. Officers cannot rename section titles, which would produce an invalid OIO.
 *   3. The FIXED_SECTIONS registry remains the single source of truth for
 *      section identity across backend and frontend.
 */
export const ProtectHeadings = Extension.create({
  name: "protectHeadings",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("protectHeadings"),
        filterTransaction(tr: any) {
          if (!tr.docChanged) return true

          let safe = true

          tr.steps.forEach((step: any) => {
            step.getMap().forEach((oldStart: number, oldEnd: number) => {
              tr.before.nodesBetween(oldStart, oldEnd, (node: any) => {
                if (node.type.name === "heading") {
                  safe = false
                }
              })
            })
          })

          return safe
        },
      }),
    ]
  },

  addGlobalAttributes() {
    return [
      {
        types: ["heading"],
        attributes: {
          class: {
            default: "oio-section-heading",
            parseHTML: () => "oio-section-heading",
            renderHTML: () => ({ class: "oio-section-heading" }),
          },
        },
      },
    ]
  },
})
